import { atom } from "recoil";

// create atom for recaptcha
export const recaptchaAtom = atom({
  key: "captcha",
  default: 0,
});
